import React from 'react';
import { useLocation } from 'react-router-dom';
import './DevelopmentBanner.css';

/**
 * Banner que indica que la aplicación está en modo desarrollo
 * Solo se muestra cuando se ejecuta en localhost
 */
const DevelopmentBanner = () => {
    const location = useLocation();
    const isLoginPage = location.pathname === '/login';

    const isDevelopment =
        window.location.hostname === 'localhost' ||
        window.location.hostname === '127.0.0.1' ||
        window.location.hostname.startsWith('192.168.');

    if (!isDevelopment) return null;

    return (
        <div className="dev-banner">
            <div className="dev-banner-content">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
                </svg>
                <span className="dev-banner-text">DESARROLLO</span>
                <span className="dev-banner-env">{window.location.hostname}</span>
            </div>
        </div>
    );
};

export default DevelopmentBanner;
